import { render, staticRenderFns } from "./WMDS.vue?vue&type=template&id=1fc6359e&"
import script from "./WMDS.vue?vue&type=script&lang=js&"
export * from "./WMDS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports